
export default function MapLoader() {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
    } else {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src =
        'http://webapi.amap.com/maps?v=1.4.15&callback=initAMap&key=eb2e7a17441b8c79c1f17a74bb27a5f5&plugin=AMap.ToolBar,AMap.StationSearch,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder'
      script.onerror = reject
      document.head.appendChild(script)
    }
    window.initAMap = () => {
      resolve(window.AMap)
    }
  })
}
